import { CTA } from "../../components/cards/cta";
import { Layout } from "../../components/layout";
import { HeaderSub } from "../../components/typography/headerSub";

const coreValues = [
  {
    title: "INNOVATION",
    text: "We continuously evolve to stay ahead in the fintech space by delivering smart, modern solutions.",
  },
  {
    title: "SECURITY",
    text: "Your financial safety is our top priority. We adhere to the highest security standards to protect your data and transactions.",
  },
  {
    title: "ACCESSIBILTY",
    text: "We believe financial tools should be available and affordable to everyone, regardless of location or background.",
  },
  {
    title: "CUSTOMER-CENTRICITY",
    text: "Our users are at the heart of everything we do. We listen, learn, and adapt to serve you better.",
  },
  {
    title: "INTEGRITY",
    text: "We operate with transparency, honesty, and an unwavering commitment to doing what’s right.",
  },
];

export const AboutPage = () => {
  return (
    <Layout>
      <div className="w-full">
        <img
          src="/assets/images/peopleDancing.png"
          className="block w-full max-h-[612px] object-cover"
          alt="people_dancing"
        />

        <div className="max-width py-[56px] lg:py-[80px] flex flex-col lg:flex-row gap-6 lg:gap-8">
          <HeaderSub
            header="ABOUT US"
            text="We are more than just a fintech company-we are your friendly financial companion."
            className="max-w-[620px]"
          />

          <div className="font-medium text-sm mg:text-base italic lg:not-italic lg:mt-14">
            <p className="text-base md:text-xl leading-none not-italic">
              Welcome to MyCardGlobal – Your Trusted Fintech Partner
            </p>
            <br />
            Incorporated in 2025, MyCard Tech Solutions Limited (referred to as
            “MyCardGlobal”) is a forward-thinking fintech company committed to
            simplifying and revolutionizing the way people save, manage, and
            invest money. Driven by innovation, security, and a customer-first
            mindset, we deliver smart financial solutions tailored for today’s
            digital world.
            <br />
            <br />
            Our platform, MyCardGlobal offers seamless access to financial
            services, from digital card solutions to helping individuals save
            without breaking a sweat. We have mastered how to help people save
            marginally and invest money while enjoying our ever increasing and
            competitive interest rates. they
            <br />
            <br />
            At MyCardGlobal, we believe financial empowerment through a
            sustainable savings culture should be simple, secure, and accessible
            to all. Whether you are saving through Autosave, Flexsave, Vault
            shopping for soft loan, we are here to make your financial
            experience smooth, fast, and reliable.
          </div>
        </div>

        <div className="max-width py-[32px] lg:py-[64px]">
          <HeaderSub
            header="OUR MISSION"
            text="To empower individuals and businesses with cutting-edge, secure, and user-friendly financial tools that provide seamless access to financial services-anytime, anywhere."
          />
        </div>

        <div className="max-width py-[32px] lg:py-[64px] flex flex-col gap-6">
          <p className="w-full text-sm md:text-base lg:text-lg text-primary font-medium text-center">
            OUR CORE VALUES
          </p>

          <div className="gap-4 lg:gap-8 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 items-center justify-center">
            {coreValues.map((coreValue, idx) => {
              return (
                <div
                  key={`${idx}`}
                  className="p-4 text-base flex flex-col gap-3 rounded-xl bg-primary/5 h-full"
                >
                  <p className="text-grey-900 font-bold">{coreValue.title}</p>
                  <p className="font-medium text-grey-800">{coreValue.text}</p>
                </div>
              );
            })}
          </div>
        </div>

        <img
          src="/assets/images/peopleOffice.png"
          className="block w-full max-h-[708px] object-cover"
          alt="people_dancing"
        />

        <div className="max-width py-[32px] lg:py-[64px]">
          <HeaderSub
            header="OUR TEAM"
            text="The MyCardGlobal team comprises fintech professionals, developers, financial experts, and visionaries united by a passion for digital innovation and financial inclusion. With a unique blend of industry experience and youthful energy, we are building the future of finance-one solution at a time."
          />
        </div>

        <CTA />
      </div>
    </Layout>
  );
};
